import { SsoIntegrationProviderPresetEnum } from '@lib/graphql-common';
import googleIcon from '@lib/assets/images/sso/Google.svg';
import microsoftIcon from '@lib/assets/images/sso/Microsoft.svg';
import oktaIcon from '@lib/assets/images/sso/Okta.svg';
import auth0Icon from '@lib/assets/images/sso/Auth0.svg';
import oneloginIcon from '@lib/assets/images/sso/OneLogin.svg';
import customSsoIcon from '@lib/assets/images/sso/Custom.svg';

const PROVIDER_ICON_MAP: Record<SsoIntegrationProviderPresetEnum, string> = {
  [SsoIntegrationProviderPresetEnum.Google]: googleIcon,
  [SsoIntegrationProviderPresetEnum.Microsoft]: microsoftIcon,
  [SsoIntegrationProviderPresetEnum.Okta]: oktaIcon,
  [SsoIntegrationProviderPresetEnum.Auth0]: auth0Icon,
  [SsoIntegrationProviderPresetEnum.Onelogin]: oneloginIcon,
  [SsoIntegrationProviderPresetEnum.Custom]: customSsoIcon,
};

export default function getSsoProviderIcon(
  preset: SsoIntegrationProviderPresetEnum,
): string {
  return PROVIDER_ICON_MAP[preset] || customSsoIcon;
}
